<template>
  <div class="charts-poly">
    <div class="charts-poly-chart__canvas" :id="id"></div>
  </div>
</template>

<script>
import global from "@/mixins/global.js";
export default {
  name: "chartsPoly",
  mixins: [global],
  props: {
    data: Object,
    id: String,
    days: String
  },
  data () {
    return {
      myChart: null,
      sdata: {
        value: [820, 932, 901, 934, 1290, 1330, 1320],
        name: ["08/01", "08/02", "08/03", "08/04", "08/05", "08/06", "08/07"]
      }
    };
  },
  computed: {
    setPolyData () {
      // return this.$store.state.mapShow.setPolyData;
      return this.data;
    }
  },
  methods: {
    setId: function () {
      return "charts-poly-chart__" + this.index;
    },
    SetPoly () {
      var id = this.id;
      var xdata = this.sdata.name;
      // for (let i = 0; i < this.data.value.length; i++) {}
      var ydata_01 = this.sdata.value;
      // var ydata_02 = this.data.value[1];

      //声明画布
      this.myChart = this.$echarts.init(document.getElementById(id));
      // 绘制图表
      var option = {
        // animation: false,
        // legend: {
        //   top: "10",
        //   right: "20"
        // },
        grid: {
          top: 30,
          left: 30,
          right: 30,
          bottom: 20,
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(27, 27, 34,0.6)"
          // position: function(pt) {
          //   return [pt[0], 130];
          // }
        },
        textStyle: {
          fontFamily: this.chartConfig.fontFamily
        },
        xAxis: {
          type: "category",
          axisPointer: {
            snap: true,
            lineStyle: {
              color: "#df4545",
              opacity: 0.5,
              width: 2
            },
            label: {
              show: true,
              formatter: "{value}",
              // fontFamily: 'Courier New',
              backgroundColor: "#df4545"
            }
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            color: '#383e47'
          },
          axisLine: {
            lineStyle: {
              color: "#dcdddd"
            }
          },
          axisTick: {
            alignWithLabel: true
          },
          data: xdata
        },
        yAxis: {
          type: "value",
          minInterval: 1,
          nameTextStyle: {
            color: '#000000'
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            color: "#383e47"
          },
          axisLine: {
            lineStyle: {
              color: "#dce0e4"
            }
          },
          z: 10
        },
        label: {
          show: this.days != '30',
          position: "top",
          fontSize: "15"
        },
        series: [
          {
            name: "数量",
            type: "line",
            // smooth: true,
            // symbol: "emptyCircle",
            symbol: "circle",
            symbolSize: 8,

            // sampling: "average",
            itemStyle: {
              normal: {
                color: "#df4545"
                // borderWidth: 2,
              }
            },
            // stack: 'a',
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#fbe5e5"
                  },
                  {
                    offset: 1,
                    color: "#fff"
                  }
                ])
              }
            },
            data: ydata_01
          }
          // {
          //   name: "物理双路由",
          //   type: "line",
          //   // smooth: true,
          //   // stack: 'a',
          //   // symbol: "emptyCircle",
          //   symbol: "circle",
          //   symbolSize: 8,
          //   sampling: "average",
          //   itemStyle: {
          //     normal: {
          //       color: "#3b6fe7"
          //     }
          //   },
          //   areaStyle: {
          //     normal: {
          //       color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
          //         {
          //           offset: 0,
          //           // color: "#d0deff"
          //           color: "#bacfff"
          //         },
          //         {
          //           offset: 1,
          //           color: "#fff"
          //         }
          //       ])
          //     }
          //   },
          //   data: ydata_01
          // }
        ]
      };
	  if (this.id=='charts-poly-index2') {
	  	// option.tooltip.backgroundColor="#fff"
		option.grid.left = 10;
		option.xAxis.axisLabel.color = '#A6B3CC';
		option.yAxis.axisLabel.color = '#A6B3CC';
		option.xAxis.axisLine.lineStyle.color = '#187CD8';
		option.yAxis.axisLine.lineStyle.color = '#187CD8';
		option.label.fontSize = '12px';
		option.series[0].areaStyle.normal.color = new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
		          {
		            offset: 0,
		            color: "#38A0AD"
		          },
		          {
		            offset: 1,
		            color: "rgba(56, 160, 173, 0)"
		          }
		        ]);
		option.series[0].itemStyle.normal.color = '#F7FDFD';
	  }
      this.myChart.setOption(option);




    },
    selfAdaption () {
      setTimeout(() => {
        window.addEventListener("resize",  ()=> {
          this.myChart.resize();
        });
      }, 10);
    }
  },
  watch: {
    setPolyData (val) {
      if (val) {
        this.sdata = val;
        this.SetPoly();
        this.selfAdaption();
      }
    }
  },
  mounted () {
    if (this.data) {
      this.sdata = this.data;
    }
    this.SetPoly();
    this.selfAdaption();


    this.myChart.on('click', (param) => {
      this.$emit("itemClick", param);
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.charts-poly {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  &-chart {
    &__canvas {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
